import secureAxios from '../secure_axios';

const baseUrl = 'modelo-item-formulario-acompanhamento'

async function servGetModelosItemFormularioPorBloco(blocoItemId) {
    const response = await secureAxios.get(`${baseUrl}/por-bloco`, {
        params: { blocoItemId }
    })
    return response.data
}

async function servGetModelosItemFormularioPorUnidade(estabelecimentoId) {
    const response = await secureAxios.get(`${baseUrl}/por-unidade`,
        { params: { estabelecimentoId } }
    )
    return response.data
}

export {
    servGetModelosItemFormularioPorBloco,
    servGetModelosItemFormularioPorUnidade
}